import { Component, defineComponent, provide } from 'vue';
import NoResults from './NoResultsRecommendations.class';
import { DisciplineSuggestions, LocationSuggestions, SelectedFilters } from '@studyportals/search-filters';
import { FilterKey, FilterProviderKey, ISelectedFiltersOptions } from '@studyportals/search-filters/server-side';
import FilterProvider from '../filters/FilterProvider';
import Recommendations from './Recommendations/Recommendations.vue';

export default defineComponent({
	components: {
		SelectedFilters: SelectedFilters as Component,
		DisciplineSuggestions: DisciplineSuggestions as Component,
		LocationSuggestions: LocationSuggestions as Component,
		Recommendations: Recommendations as Component
	},
	setup: () => {
		provide(FilterProviderKey.FILTER_PROVIDER, FilterProvider.instance);
		provide(FilterProviderKey.LOCATION_FILTER_PROVIDER, FilterProvider.instance);

		const component = new NoResults();

		const selectedFiltersOptions: ISelectedFiltersOptions = {
			displayClearAll: false,
			collapseToDefaultNumberOfRows: false,
			displayTitle: false,
		};

		return {
			disciplineFilterKey: FilterKey.DISCIPLINES,
			regionFilterKey: FilterKey.AREA,
			countryFilterKey: FilterKey.COUNTRY,
			continentFilterKey: FilterKey.CONTINENT,
			selectedFiltersOptions,
			pageTitle: component.pageTitle,
			resultsCount: component.resultsCount,
			maxNumberOfResultsForSuggestions: component.MAX_NUMBER_OF_RESULTS_FOR_SUGGESTIONS,
			trackingDisplaySection: 'suggestion'
		};
	},
});
